import { forwardRef } from 'react'
import classNames from 'classnames'
import injectSheet from 'react-jss'
import { useSelector, shallowEqual } from 'react-redux'
import DelayLink from '@/components/DelayLink'
import BtnLink from '@/components/BtnLink'
import Social from '@/components/Social'
import style from './style'

const Footer = forwardRef(({
  classes,
  storeLocator,
  background,
}, ref) => {
  const { footerNav, strings } = useSelector((state) => ({
    footerNav: state.nav.footer_menu || [],
    strings: state.language.string,
  }), shallowEqual)

  const renderFooterLocator = () => {
    return storeLocator && (
      <div className={classes.locator}>
        <h2 dangerouslySetInnerHTML={{ __html: strings.footer_locator_title }} />
        <div
          className={classes.locatorText}
          dangerouslySetInnerHTML={{ __html: strings.footer_locator_text }}
        />
        <div className={classes.locatorBtns}>
          <BtnLink
            label={strings.storefinder_label}
            link={strings.storefinder_link}
            theme="orange"
            fill
          />
          <BtnLink
            label={strings.appointment_label}
            link={strings.appointment_link}
            theme="orange"
          />
        </div>
      </div>
    )
  }

  const renderFooterTop = () => {
    return (
      <div
        className={classNames({
          [classes.container]: true,
          [classes.containerLight]: background === 'light',
          [classes.containerTop]: !storeLocator,
        })}
      >
        <div
          className={classNames({
            [classes.wrapper]: true,
            [classes.wrapperTop]: true,
          })}
        >
          <div className={classes.footerBox}>
            <div className={classes.left}>
              <h2 dangerouslySetInnerHTML={{ __html: strings.footer_title }} />
              <div className={classes.footer__social}>
                <Social strings={strings} />
              </div>
              <div className={classes.iconsList}>
                <div className={classes.itemList}>
                  <svg><use xlinkHref="#ico-location" /></svg>
                  <div dangerouslySetInnerHTML={{ __html: strings.footer_address }} />
                </div>
                <div className={classes.itemList}>
                  <svg><use xlinkHref="#ico-phone" /></svg>
                  <p dangerouslySetInnerHTML={{ __html: strings.footer_tel }} />
                </div>
                <div className={classes.itemList}>
                  <svg><use xlinkHref="#ico-mail" /></svg>
                  <BtnLink
                    link={strings.appointment_link}
                    label={strings.footer_cta}
                    label2={strings.footer_cta2}
                    theme="light"
                    fill
                    slim
                  />
                </div>
              </div>
            </div>
            <div className={classes.right}>
              <ul className={classes.footerMenu}>
                {footerNav.map((item) => (
                  <li
                    key={item.ID}
                    className={item.classes.join(' ')}
                  >
                    <DelayLink to={item.url}>
                      {item.title}
                    </DelayLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderFooterBottom = () => {
    return (
      <div
        className={classNames({
          [classes.container]: true,
          [classes.containerBottom]: true,
        })}
      >
        <div
          className={classNames({
            [classes.wrapper]: true,
            [classes.wrapperBottom]: true,
          })}
        >
          <div className={classes.logo}>
            <svg><use xlinkHref="#ico-logo" /></svg>
          </div>
          <div className={classes.footerCopy}>
            <div dangerouslySetInnerHTML={{ __html: strings.footer_copy }} />
            <div dangerouslySetInnerHTML={{ __html: strings.footer_copy2 }} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <footer
      className={classNames({
        [classes.root]: true,
        Footer__root: true,
        [classes.rootLight]: storeLocator,
      })}
      ref={ref}
    >
      {renderFooterLocator()}
      {renderFooterTop()}
      {renderFooterBottom()}
    </footer>
  )
})

Footer.defaultProps = {
  storeLocator: false,
}

export default injectSheet(style)(Footer)
